module.exports = __webpack_public_path__ + "images/Yunji-329341.png";